import React from 'react';

import './loader.scss';

export const Loader = () => (
  <div className="loader">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);
